import { SelectType } from "@/enum/list.enum";

import { Sender } from "@/pages/Private/pages/List/components/CampaignOverview/components/Sender";
import { campaignSendersFor } from "@/pages/Private/pages/Messages/utils/campaignSenders";

import {
	reachOutBulkScope,
	ReachOutTarget,
	reachOutTargetLeads,
	reachOutTargetListId,
} from "../reachOutTarget";
import { CampaignConnectionCheck } from "./campaignConnections.api";

/**
 * The LinkedIn senders the campaign would send as for this target (PREC-4426), by user id: who
 * "Add to campaign" sends as (`campaignSendersFor`, the API's order), LinkedIn only. For a bulk
 * selection, the union over the loaded leads and the campaign's own senders.
 */
export function connectionCheckSenderIds(
	target: ReachOutTarget,
	campaign: { senders?: Sender[] },
	override?: Sender[]
): number[] {
	const loaded = reachOutTargetLeads(target).flatMap((row) =>
		campaignSendersFor({ override, prospect: row, campaign })
	);
	const rest = target.kind === "bulk" ? campaignSendersFor({ override, campaign }) : [];

	return [
		...new Set(
			[...loaded, ...rest]
				.filter((sender) => sender.type === "linkedin")
				.map((sender) => sender.userId)
		),
	];
}

/** The check's request: the selection exactly as `bulkAssign` receives it from the picker. */
export function buildConnectionCheckArgs(
	target: ReachOutTarget,
	campaignId: string,
	senderUserIds: number[]
): CampaignConnectionCheck {
	if (target.kind === "lead") {
		return {
			listId: reachOutTargetListId(target),
			assign: [{ listPersonId: target.row.id, campaignId }],
			selectType: SelectType.CURRENT_PAGE,
			senderUserIds,
		};
	}

	return {
		listId: target.listId,
		assign: target.selectedItems.map((id) => ({ listPersonId: id, campaignId })),
		...reachOutBulkScope(target),
		senderUserIds,
	};
}
